export default __webpack_public_path__ + "static/media/total-females.582c0118.png";